/* screens/settings/BusinessUpgradeWizard.jsx — создание бизнес-пространства (window.BusinessUpgradeWizard).
   ОДНО окно (без шагов и без реквизитов): название + выбор тарифа + срок оплаты
   (1 / 3 / 6 / 12 мес. со скидкой). Первым в линейке — БЕСПЛАТНЫЙ «Быстрый старт»
   (biz_demo, 0 ₽ / 7 дней, price из API): рекомендованный путь без карты — ws
   создаётся и тут же активируется бесплатный период (POST /api/subscription/trial/),
   без checkout; успех — финальная панель, активное пространство переключается на
   новое (тот же switchWorkspace, что у WorkspaceSwitcher). Платные тарифы — прежний
   путь: ws появляется в момент «Оплатить» (создание ws + checkout одной операцией).
   «Быстрый старт» — ОДИН на владельца, и этот мастер — единственный вход в него.
   Тому, кто свой уже использовал (quick_start_available === false из
   /api/subscription/me/, спрашиваем при каждом открытии), бесплатный тариф не
   показываем: выбор по умолчанию — первый платный. Активация периода повторяется
   при сбое; если он так и не включился — тост зовёт в поддержку, потому что
   включить бесплатный период вне мастера (в т.ч. на вкладке «Тариф») нечем.
   ПЕРСОНАЛЬНЫЙ ТАРИФ. Сотруднику администрация может выдать именной закрытый
   бесплатный тариф; в том же ответе /me/ он приходит ключом `personal_plan`
   {plan, duration_days, workspaces_used, workspaces_max}. Тогда первой карточкой
   (и выбором по умолчанию) идёт ОН, а «Быстрого старта» в линейке нет — доступен
   тот владельцу или нет; платные тарифы остаются. Путь — тот же бесплатный:
   создание ws → POST /trial/ → переключение → финал; меняются только подписи.
   Карточка называет тариф, срок доступа («Бессрочно» / «N дней» — из
   `duration_days`) и то, что он выдан этому аккаунту; ни «7 дней», ни «без
   карты», ни выбора срока оплаты: `plan.period_days` у него — окно квот, а не
   срок. Суммы и «/ мес» на карточке нет — строка цены читается «По договору»
   (общее правило закрытых тарифов с нулевой ценой, planPrice.js; так же её
   покажет вкладка «Тариф»). В переключателе линейки тариф подписан коротко —
   «Персональный», полное имя — на карточке. Кнопка — «Создать пространство».
   Исход 'granted': пространство открыто, финал называет тариф и срок из ответа
   /trial/ («бессрочно» / «до <дата>»). Право на карточку и исход решает сервер:
   мастер показывает то, что пришло, и верит статусу — в том числе 'granted' на
   карточке «Быстрого старта» (ответ /me/ опоздал к таймеру) и прежние исходы на
   карточке персонального тарифа (выдачу отозвали).
   Неудача на этой карточке называется своими словами: сбой активации — «тариф
   не подключился, напишите в поддержку», без «бесплатного периода» и без совета
   выбрать тариф (выдача цела, её подключит поддержка); 'demo_used' — «персональный
   тариф недоступен», выбрать тариф предлагаем (сервер ответил по ветке «Быстрого
   старта» — выдачи уже нет). На «Тариф» ведём в обоих случаях: строка статуса
   там — правда для любого пути. Создание может ответить 400
   workspace_limit_reached (лимит пространств по выдаче) — текст отказа показывает
   общий тост ошибки.
   Витрину тарифов персональная карточка ждёт не дольше шести секунд от открытия
   (ей из витрины ничего не нужно): дальше показывается одна, платные тарифы
   встают рядом, когда придут. Без выдачи витрину ждём как раньше.
   После исхода, оставившего пространство ЗАКРЫТЫМ ('demo_used' / сбой активации),
   финал не говорит «готово к работе», а человек попадает на вкладку «Тариф»
   нового пространства: строка статуса на карточке тарифа говорит правду.
   ФИНАЛ ЖИВЁТ НЕДОЛГО: мастер смонтирован внутри .settings-content, а тот
   перемонтируется по key = id активного пространства (SettingsScreen). Удачный
   switchWorkspace меняет активное пространство — и мастер исчезает вместе с
   финалом, как только AuthProvider перечитает список пространств (а если прежнее
   активное пространство не первое в списке — сразу, до финала). В квесте
   онбординга пространство переключает ещё и оверлей — по 'onb:ws-created', не
   дожидаясь /trial/. Поэтому всё, что человек обязан узнать, несут тост и экран
   под мастером; финальную панель надолго видит только тот, у кого переключение
   не удалось.
   Платный путь сам пространство не переключает до УХОДА на оплату (activate):
   развилка «карта / счёт» (безнал Точки) и окно согласия на автосписания
   (RecurringConsentModal, шрам S33) живут внутри мастера и идут после создания ws.
   Но квест онбординга переключает пространство по 'onb:ws-created' — и эти шаги
   исчезают вместе с мастером. Поэтому перед развилкой и перед согласием мастер
   тоже открывает вкладку «Тариф»: исчез мастер — человек стоит на тарифах, где
   оплата предлагается снова.
   На «Тариф» ведём, только если человек стоит там же, где запустил создание
   (tariffRedirect): прогон идёт секунды, и уйти за это время он мог куда угодно.
   ОДНО ПРОСТРАНСТВО НА СЕАНС: пространство без срока закрыто (no_plan) и занимает
   место в лимите владельца, так что дубль — не безобидная строка в списке.
   Созданное пространство мастер помнит до закрытия (createdRef) и любой повторный
   вход — устаревший второй вызов, повтор после отказа оплаты, закрытая развилка
   или закрытое окно согласия — ведёт в него же, а не создаёт новое; поле
   названия после создания заблокировано (createdWs).
   Пока создание идёт, мастер заперт: крестик, фон и «Отмена» не закрывают (см.
   requestClose), а если прогон затянулся — окно объясняет, что делать.
   Правила и тексты — quickStart.js (чистая логика, vitest).
   Квест онбординга: сразу после создания ws (оба пути, до редиректа в оплату)
   шлём событие 'onb:ws-created' {workspaceId}. Реквизиты заведения заполняются
   позже — в настройках бизнес-пространства (BusinessRestaurantTab), не при создании.
   onCreated(ws) — родитель запоминает id созданного пространства; список он
   перечитывает и выбирает новое на закрытии мастера (BusinessSection).
   ХЕНДОФФ → frontend/pages/settings/BusinessUpgradeWizard.jsx. */

import React from 'react';
import ReactDOM from 'react-dom';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { InvoicePayModal } from '../../components/patterns/InvoicePayModal.jsx';
import { PaymentMethodModal } from '../../components/patterns/PaymentMethodModal.jsx';
import { PlanCard, periodSuffix } from '../../components/patterns/PlanCard.jsx';
import { buildOptions } from '../../components/patterns/PlanPeriodModal.jsx';
import { RecurringConsentModal } from '../../components/patterns/RecurringConsentModal.jsx';
import { Pill } from '../../components/ui/Badge.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Field, Segmented, TextInput } from '../../components/ui/Field.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { hooks } from '../../hooks/index.jsx';
import { authReal } from '../../lib/adapters/auth.js';
import { subscriptionReal } from '../../lib/adapters/subscription.js';
import * as subApi from '../../lib/api/subscription.js';
import { fmt } from '../../lib/format.js';
import { getOverlayRoot } from '../../lib/overlay.jsx';
import { consentNeededForPlan, isConsentRequiredError } from '../../lib/recurringConsent.js';
import { RR } from '../../lib/router.jsx';
import { usePhoneGate } from '../../components/patterns/PhoneGate.jsx';
import {
  BUSY_SLOW_HINT_MS, QUICK_START_CHECK_TIMEOUT_MS, TARIFF_TAB_URL,
  closedPanelText, grantTermLabel, grantedPanelText, personalOffer, resolveTrialStatus,
  shouldOfferQuickStart, startTrialWithRetry, tariffRedirect, tierLabel, trialOutcome,
  wizardTiers, workspacesUsageLabel,
} from './quickStart.js';

  const { useState, useEffect, useRef } = React;
  const { useFakeQuery } = hooks;
  const { useNavigate } = RR;

  const monthsLabel = (m) => m + ' ' + fmt.plural(m, 'месяц', 'месяца', 'месяцев');

  // Адрес «прямо сейчас» — из window.location, а не из useLocation(): прогон
  // создания живёт дольше перерисовки и дольше самого мастера (его размонтирует
  // смена активного пространства), а состояние роутера в замыкании — снимок на
  // момент клика. Роутер в history-режиме, адрес в window.location — истина.
  const hereNow = () => {
    try { return { pathname: window.location.pathname, search: window.location.search }; }
    catch { return null; }
  };

  function BusinessUpgradeWizard({ open, onClose, onCreated }) {
    const toast = useToast();
    const navigate = useNavigate();
    const { switchWorkspace, user } = useAuth();
    const [name, setName] = useState('');
    const [tierSlug, setTierSlug] = useState(null);   // базовый (месячный) biz-тариф S/M/L
    const [months, setMonths] = useState(1);          // срок оплаты: 1 / 3 / 6 / 12
    const [err, setErr] = useState(null);
    const [busy, setBusy] = useState(false);
    // Идёт ли создание (payNow / cardCheckout) — то же, что `busy`, но читается
    // сразу, а не со следующей перерисовки: по нему requestClose не даёт закрыть
    // мастер посреди создания, а payNow не входит повторно.
    const busyRef = useRef(false);
    // Пространство, созданное в ЭТОМ сеансе мастера (до close). Пока оно есть,
    // createBusinessWorkspace больше не зовём: повторный payNow продолжает с ним.
    // Ref, а не состояние: устаревший вызов из прошлой перерисовки обязан его видеть.
    const createdRef = useRef(null);
    // Прогон идёт дольше BUSY_SLOW_HINT_MS — показываем подсказку (см. эффект ниже).
    const [slow, setSlow] = useState(false);
    const phoneGate = usePhoneGate();
    // Финал бесплатного пути («Быстрый старт» или персональный тариф):
    // {name, status, closed, personal, days, planName, expiresAt} — панель вместо
    // формы (платный путь уходит в checkout и финала внутри модалки не имеет).
    // status — итог активации, closed — пространство осталось закрытым (quickStart.js);
    // personal — прогон шёл с карточки персонального тарифа (неудача называется
    // его словами); planName и expiresAt — для исхода 'granted': какой тариф
    // подключён и до когда.
    const [done, setDone] = useState(null);
    // Безнал (Точка): после создания ws на платном тарифе — развилка «карта/счёт».
    // {ws, slug} для PaymentMethodModal; invoiceCtx — открытая форма реквизитов счёта.
    const [payMethod, setPayMethod] = useState(null);
    const [invoiceCtx, setInvoiceCtx] = useState(null);
    // Согласие на автосписания перед оплатой картой: {slug, wsId} для RecurringConsentModal.
    const [consentCtx, setConsentCtx] = useState(null);
    // Пространство, уже созданное этим окном, — зеркало createdRef для РИСОВАНИЯ.
    // Повторное «Оплатить» решает createdRef (его видит и устаревший вызов), а по
    // этому состоянию блокируется поле названия: переименование после создания
    // плодило бы заведения (старое осталось бы сиротой без тарифа).
    const [createdWs, setCreatedWs] = useState(null);
    // Безнал доступен, когда включён фиче-флаг Точки (владелец нового ws — админ по определению).
    const showInvoicePay = !!(user && user.tochka_invoicing_enabled);
    // Что предлагать бесплатно: null — ещё не знаем (ждём /api/subscription/me/),
    // дальше {quickStart, personal}: quickStart — предлагать ли «Быстрый старт»,
    // personal — выданный зрителю персональный тариф (personalOffer) либо null.
    // Оба факта — из ОДНОГО ответа и одним значением состояния: порознь линейка
    // успела бы нарисоваться с «Быстрым стартом» и тут же смениться персональным
    // тарифом. Спрашиваем при КАЖДОМ открытии, а не один раз: ответ меняется прямо
    // в этой сессии — создал заведение на «Быстром старте», нажал «Ещё заведение»,
    // и бесплатного периода уже нет; выдачу тарифа могли отозвать.
    // Оба — про пользователя, а не про пространство, поэтому хватает активного ws.
    // Запрос упал → как раньше, предлагаем «Быстрый старт», персонального тарифа
    // нет (что включить, всё равно решит /trial/ — в том числе выданный тариф).
    // Запрос завис → то же самое по таймеру: пока ответа нет, линейки нет и создать
    // нельзя даже платное пространство. Это ГОНКА, первый исход окончателен: ответ,
    // опоздавший к таймеру, уже показанную линейку не перестраивает («Начать
    // бесплатно» не превращается в «Оплатить» или «Создать пространство» под
    // рукой). Ответ и таймер прошлого открытия (закрыл до ответа, открыл снова)
    // новому сеансу не принадлежат.
    const [freeOffer, setFreeOffer] = useState(null);
    // Истекло ли ожидание ВИТРИНЫ тарифов для персональной карточки (lineupReady
    // ниже). Отсчёт тот же, что у ответа /me/, — шесть секунд ОТ ОТКРЫТИЯ мастера
    // и тем же таймером: человек ждёт окно, а не каждый запрос по отдельности.
    // Тем, кому тариф не выдан, флаг ничего не меняет — их линейка приходит из
    // витрины, и ждут они её как раньше.
    const [catalogueWaitOver, setCatalogueWaitOver] = useState(false);
    useEffect(() => {
      if (!open) { setFreeOffer(null); setCatalogueWaitOver(false); return undefined; }
      let alive = true;
      const decide = (sub) => {
        if (!alive) return;
        alive = false;
        setFreeOffer({ quickStart: shouldOfferQuickStart(sub), personal: personalOffer(sub) });
      };
      const timer = setTimeout(() => {
        decide(null);
        setCatalogueWaitOver(true);
      }, QUICK_START_CHECK_TIMEOUT_MS);
      subscriptionReal.getSubscription().then(decide, () => decide(null));
      return () => { alive = false; clearTimeout(timer); };
    }, [open]);

    // Запертое окно обязано объясниться. Пока прогон идёт, мастер не закрыть, а у
    // запросов нет таймаута: зависший запрос оставил бы человека перед крутящейся
    // кнопкой без единого слова. Отсчёт привязан к `busy`: прогон кончился, мастер
    // закрыли или размонтировали (смена пространства) — чистка эффекта снимает
    // таймер. Флаг сбрасываем на КОНЦЕ прогона, а не на старте следующего: иначе
    // подсказка прошлого прогона мелькнула бы в начале нового.
    useEffect(() => {
      if (!busy) { setSlow(false); return undefined; }
      const timer = setTimeout(() => setSlow(true), BUSY_SLOW_HINT_MS);
      return () => clearTimeout(timer);
    }, [busy]);

    // Тарифы заведения, только базовые месячные (slug без _<N>m) — из них
    // выбираем S/M/L; длинные варианты подтянем как периоды семейства.
    // Аудиторию берём из поля `audience` (адаптер её уже нормализовал), как и
    // тарифная панель, а не из наличия фичи team_members: это был косвенный
    // признак, и бизнес-тариф с пустыми фичами в визарде просто не показывался.
    const plansQ = useFakeQuery('wizard-plans', () => subscriptionReal.listPlans(), []);
    const allPlans = plansQ.data || [];
    const isVariant = (p) => /_\d+m$/.test(p.slug);
    // Витрина визарда — тарифы для НОВОГО пространства, то есть только публичная
    // линейка. Свой закрытый тариф сервер кладёт в тот же ответ `/plans/` (он
    // приходит для АКТИВНОГО пространства), и без отсечения сетевой клиент
    // выбрал бы его здесь, а упёрся бы в отказ checkout'а — уже создав заведение.
    // Отсекаем по `is_private`, а не по слагу: для нового пространства текущий
    // тариф активного — законный кандидат (сеть на biz_m заводит второе
    // заведение на biz_m), и отсечение по слагу отняло бы у клиента выбор.
    const publicBases = allPlans.filter(
      (p) => p.audience === 'business' && !isVariant(p) && !p.is_private);
    // Бесплатный «Быстрый старт» остаётся в линейке, только пока он владельцу
    // доступен (wizardTiers). Пока ответа нет — линейка пуста и на её месте
    // скелетон: иначе бесплатный тариф мелькнул бы выбранным и исчез.
    // Персональный тариф (если выдан) встаёт первым ВМЕСТО «Быстрого старта». Он
    // приходит в /me/ целиком и из витрины ему ничего не нужно, но раньше неё
    // стараемся не показывать — платные тарифы встали бы рядом уже под рукой.
    // Ждём, пока витрина ГРУЗИТСЯ, и не дольше шести секунд от открытия
    // (catalogueWaitOver): зависшая витрина не должна держать на скелетоне того,
    // кому она не нужна. Не дождались или она не пришла вовсе — карточка одна, и
    // это рабочий путь; придёт позже — платные встанут рядом, а выбор останется
    // на персональном (он первый в линейке и до, и после). Без выдачи пустая
    // витрина — прежний скелетон, сколько бы она ни грузилась: «Быстрый старт» и
    // платные тарифы приходят ИЗ неё.
    const personal = freeOffer ? freeOffer.personal : null;
    const awaitingCatalogue = !!personal && plansQ.loading && !catalogueWaitOver;
    const lineupReady = freeOffer !== null && !awaitingCatalogue;
    const bizBases = lineupReady ? wizardTiers(publicBases, freeOffer.quickStart, personal) : [];

    // Карта длинных вариантов по базовому слагу: biz_s → [{plan, months}…].
    const variantsByBase = {};
    allPlans.forEach((p) => {
      const m = /^(.+)_(\d+)m$/.exec(p.slug);
      if (m) (variantsByBase[m[1]] = variantsByBase[m[1]] || []).push({ plan: p, months: Number(m[2]) });
    });

    const tier = bizBases.find((p) => p.slug === tierSlug) || bizBases[0] || null;
    // Выбран персональный тариф. Признак — сама выдача, а не цена: по цене мастер
    // отличает оплату от бесплатного пути, и тариф с ценой в карточке увёл бы
    // выданное бесплатно в checkout закрытого слага — уже создав заведение.
    const isPersonal = !!(personal && tier && tier.slug === personal.plan.slug);
    // Срока оплаты (1 / 3 / 6 / 12 мес.) у персонального тарифа нет — его не покупают.
    const family = tier
      ? { base: tier, variants: isPersonal ? [] : (variantsByBase[tier.slug] || []) }
      : null;
    const options = buildOptions(family);           // [{plan, months, full, perMonth, savings, discountPct}]
    const selected = options.find((o) => o.months === months) || options[0] || null;
    const bestPct = options.reduce((mx, o) => Math.max(mx, o.discountPct), 0);
    // «Быстрый старт» (biz_demo, 0 ₽): цена из API — бесплатная опция идёт первой
    // (plans отсортированы по price_rub) и становится дефолтным выбором. Если он
    // владельцу уже недоступен, его в линейке нет — дефолтом выходит первый платный.
    const isFastStart = !isPersonal && !!(selected && Number(selected.plan.price_rub) === 0);
    // Бесплатный путь (POST /trial/ без checkout) — у обоих; различаются подписи.
    const isFreePath = isPersonal || isFastStart;
    // Подписи карточки персонального тарифа (quickStart.js). Срок — из выдачи
    // (duration_days), а не plan.period_days: то окно квот.
    const personalTerm = isPersonal ? grantTermLabel(personal.duration_days) : '';
    const personalUsage = isPersonal ? workspacesUsageLabel(personal) : '';
    // Карточке персонального тарифа цену не отдаём: пространство садится на него
    // без оплаты, и «4 900 ₽ / мес» над кнопкой «Создать пространство» было бы
    // неправдой. Нулевую цену закрытого тарифа карточка подписывает «По договору»
    // (planPrice.js) — тем же правилом, что и вкладка «Тариф» после создания.
    const cardPlan = isPersonal ? { ...tier, price_rub: 0, is_private: true } : tier;

    // Сброс формы и закрытие — конец сеанса мастера: кнопку освобождаем, созданное
    // пространство забываем (следующее открытие — решение создать ещё одно).
    // Зовётся кнопками футера и самим мастером (уход в оплату); крестик и фон идут
    // через requestClose.
    const close = () => {
      busyRef.current = false; createdRef.current = null;
      setName(''); setTierSlug(null); setMonths(1); setErr(null); setBusy(false); setDone(null);
      setPayMethod(null); setInvoiceCtx(null); setConsentCtx(null);
      setCreatedWs(null);
      onClose && onClose();
    };
    // Крестик и фон: пока идёт создание — ничего не делаем. Иначе форма сбрасывалась
    // посреди прогона (а с повторами /trial/ это секунды): человек открывал мастер
    // снова, видел пустую активную форму и создавал ВТОРОЕ пространство, а финал
    // первого прогона прилетал уже в новое открытие.
    const requestClose = () => { if (busyRef.current) return; close(); };
    // Начало и конец прогона создания (payNow / cardCheckout).
    const beginRun = () => { busyRef.current = true; setBusy(true); };
    const endRun = () => { busyRef.current = false; setBusy(false); };
    // Открыть вкладку «Тариф» нового пространства — если человек всё ещё там, где
    // запустил создание (startedAt — адрес на старте прогона, см. tariffRedirect).
    const goToTariff = (startedAt) => {
      const opts = tariffRedirect(startedAt, hereNow());
      if (opts) navigate(TARIFF_TAB_URL, opts);
    };
    if (!open) return null;

    // Сделать новое пространство активным — в момент УХОДА на оплату, а не сразу
    // после создания. SettingsScreen перемонтирует содержимое при смене активного
    // пространства (key по activeWorkspace.id), и вместе с ним исчезал бы этот
    // мастер — со всеми шагами, которые идут после создания ws: выбор способа
    // оплаты и согласие на автосписания остались бы без экрана. Цель переключения
    // прежняя: вернувшись после оплаты, человек попадает в созданное заведение, а
    // не в личное пространство. Ошибку глотаем — оплату из-за неё ронять нельзя.
    const activate = async (wsId) => {
      try { await switchWorkspace(wsId); } catch { /* noop */ }
    };

    // Карточная оплата (Робокасса): checkout по slug на созданное ws → редирект
    // (мок-шлюз за DEBUG — внутренний hash-роут). Общая для прямого пути и развилки.
    // consent=true — человек поставил галочку согласия на автосписания (см. payByCard).
    const cardCheckout = async (slug, wsId, consent) => {
      beginRun();
      try {
        const r = await subscriptionReal.startCheckout(slug, wsId, undefined, consent);
        // Счёт создан — уходим платить. После activate мастер размонтирован:
        // ниже только навигация, состояние этого окна больше не трогаем.
        if (r && r.redirect_url) await activate(wsId);
        if (r && r.invoice_id && r.redirect_url && /\/checkout\/mock\//.test(r.redirect_url)) {
          close(); navigate('/checkout/mock/' + encodeURIComponent(r.invoice_id) + '?ws=' + encodeURIComponent(wsId)); return;
        }
        if (r && r.redirect_url) { window.location.href = r.redirect_url; return; }
        toast.show('Не удалось начать оплату', 'danger');
      } catch (e) {
        // Сервер требует согласие, а экран его не спросил — открываем то же окно
        // с галочкой вместо тупика с тостом.
        if (isConsentRequiredError(e) && !consent) { setConsentCtx({ slug, wsId }); return; }
        toast.show((e && e.detail) || (e && e.message) || 'Не удалось начать оплату', 'danger');
      }
      finally { endRun(); }
    };
    // Оплата картой привязывает карту к автопродлению — перед уходом в Робокассу
    // показываем условия и обязательную галочку (разовым тарифам она не нужна).
    const payByCard = (slug, wsId) => {
      if (consentNeededForPlan(allPlans.find((p) => p.slug === slug))) { setConsentCtx({ slug, wsId }); return undefined; }
      return cardCheckout(slug, wsId);
    };

    // Создание бизнес-пространства: бесплатный путь («Быстрый старт» или персональный
    // тариф) сажает ws на тариф без оплаты; платный тариф — создаём ws и сразу
    // уходим в checkout за выбранный срок.
    const pay = () => {
      if (!selected) return;
      if (!name.trim()) { setErr('Укажите название пространства'); return; }
      // Телефон спрашиваем на ОБОИХ путях, включая бесплатный («Быстрый старт» и
      // персональный тариф):
      // контакт нужен не ради платежа, а чтобы было как связаться по доступу.
      // Того, у кого номер уже есть, гейт не спросит — в том числе если человек
      // оставил его на бизнес-демо-стенде (заявка переносится в профиль при
      // регистрации, accounts.views.adopt_lead_phone).
      return phoneGate.run(payNow);
    };
    const payNow = async () => {
      // Повторный вход, пока прогон идёт, — не новый прогон. Сюда приводит
      // устаревший второй вызов: кнопка из прошлой перерисовки (её `disabled` ещё
      // не знает про `busy`) или второе срабатывание шага с телефоном.
      if (busyRef.current) return;
      beginRun();
      const startedAt = hereNow();
      try {
        // Пространство создаём ОДИН раз за сеанс мастера. Повтор после неудачи
        // (оплата не началась, развилку способа оплаты или окно согласия закрыли)
        // приходит сюда же при уже созданном пространстве: продолжаем с ним —
        // оплата или активация идут ему, а не дублю. Родителю и квесту о нём уже
        // сообщили.
        let targetWs = createdRef.current;
        if (!targetWs) {
          targetWs = await authReal.createBusinessWorkspace({ name: name.trim() });
          createdRef.current = targetWs;
          setCreatedWs(targetWs);               // поле названия блокируется (см. createdWs)
          if (onCreated) onCreated(targetWs);   // родитель запоминает id — НЕ меняет активное ws и список пока не перечитывает
          // Квест онбординга: ws создан — сигналим оверлею сразу (оба пути, платный —
          // до редиректа в оплату, чтобы шаг успел зачесться).
          try { window.dispatchEvent(new CustomEvent('onb:ws-created', { detail: { workspaceId: targetWs.id } })); } catch { /* noop */ }
        }

        if (isFreePath) {
          // Бесплатный путь: POST /trial/ сажает ws на тариф БЕЗ checkout — на
          // biz_demo (7 дней) либо на персональный тариф владельца ('granted').
          // Какой из двух включить, решает сервер: карточку мастер не присылает,
          // и 'granted' может прийти на карточке «Быстрого старта» (ответ /me/
          // опоздал к таймеру), а прежние статусы — на карточке персонального
          // тарифа (выдачу отозвали). Статусу верим в обе стороны.
          // Пространство к этому моменту УЖЕ создано, поэтому активацию повторяем при
          // сбое (до двух повторов; эндпоинт идемпотентен) и при любом исходе идём к
          // финалу — startTrialWithRetry наружу не бросает. Статусы 'already'/
          // 'paid_plan'/'demo_used' — не ошибка (контракт C4; 'already' может нести
          // прошедший expires_at, а 'demo_used' = кап «один «Быстрый старт» на
          // владельца»): период как активный НЕ рисуем, тост говорит, что делать
          // дальше. Период так и не включился → тост зовёт в поддержку: включить его
          // вне этого мастера нечем (тексты — trialOutcome в quickStart.js).
          // 'already' на ПОВТОРЕ с будущим сроком — наша же активация с потерянным
          // ответом: resolveTrialStatus отдаёт её как 'activated'.
          const trial = await startTrialWithRetry(() => subApi.startTrial(targetWs.id));
          const status = resolveTrialStatus(trial);
          // Неудача на карточке персонального тарифа называется его словами: там
          // нет «бесплатного периода», а после сбоя нельзя советовать «выберите
          // тариф» — выдача цела, её подключит поддержка (quickStart.js, правило 7).
          const outcome = trialOutcome(status, { personal: isPersonal });
          toast.show(outcome.text, outcome.tone, outcome.duration);
          // Переключаем активное пространство тем же механизмом, что и WorkspaceSwitcher
          // (сервер-сессия + localStorage X-Workspace-Id + перезагрузка списка ws) —
          // юзер остаётся в приложении уже в новом пространстве. Ошибку переключения
          // глотаем, как и на платном пути: пространство создано, и остаться на форме
          // с тостом «Не удалось начать оплату» значило бы предложить создать второе.
          try { await switchWorkspace(targetWs.id); } catch { /* noop */ }
          // Пространство осталось закрытым → открываем его вкладку «Тариф»: мастер
          // открывают с любой подвкладки («Ещё заведение» есть на каждой), и без
          // перехода человек остался бы, например, на «Команде» закрытого пространства,
          // так и не увидев строку статуса. Переход — ПОСЛЕ переключения (иначе
          // мелькнул бы тариф прежнего пространства) и ДО финала: удачное переключение
          // перемонтирует настройки вместе с мастером (см. шапку файла), а navigate
          // от этого не зависит. Удачную активацию не трогаем — человек остаётся там,
          // где был. Ушедшего за время повторов /trial/ не выдёргиваем (goToTariff).
          if (outcome.closed) goToTariff(startedAt);
          // Срок бесплатного периода (исход 'activated') — у «Быстрого старта». На
          // карточке персонального тарифа выбран не он, а period_days выбранного —
          // окно квот: берём «Быстрый старт» из витрины.
          const quickStartPlan = isPersonal
            ? publicBases.find((p) => Number(p.price_rub) === 0)
            : selected.plan;
          setDone({
            name: targetWs.name || name.trim(),
            status,
            closed: outcome.closed,
            personal: isPersonal,
            days: (quickStartPlan && quickStartPlan.period_days) || 7,
            // Исход 'granted': имя — с карточки (пустое, если персональную не
            // показывали), срок — из ответа /trial/ (null — бессрочно).
            planName: isPersonal ? selected.plan.name : '',
            expiresAt: trial.expires_at,
          });
          return;
        }

        // Платный путь переключает активное пространство в момент ухода на
        // оплату (см. activate): человек, вернувшись, должен попасть в созданное
        // заведение. Здесь, сразу после создания, переключать НЕЛЬЗЯ — мастер
        // исчез бы до шагов «способ оплаты» и «согласие на автосписания».

        // Безнал (Точка) доступен → развилка «карта / счёт» (как в тарифной
        // панели); иначе — сразу картой. ws уже создан: оба способа оплачивают
        // именно его (счёт — формой реквизитов ниже).
        // Развилка и окно согласия живут внутри мастера. Сам мастер на платном
        // пути пространство до ухода в оплату не переключает (см. activate), но
        // квест онбординга переключает его по 'onb:ws-created' — и настройки
        // перемонтируются вместе с мастером, развилкой и согласием. Поэтому перед
        // любым из этих шагов открываем «Тариф»: исчез мастер — человек стоит там,
        // где оплата предлагается снова, а строка статуса объясняет, почему
        // разделы закрыты. Разовый тариф без безнала идёт сразу на страницу
        // оплаты — ему переход не нужен.
        const slug = selected.plan.slug;
        if (showInvoicePay) {
          goToTariff(startedAt);
          setPayMethod({ ws: targetWs, slug });
          return;
        }
        // Оплата картой привязывает карту к автопродлению — сначала условия и
        // обязательная галочка (payByCard; разовым тарифам она не нужна).
        if (consentNeededForPlan(allPlans.find((p) => p.slug === slug))) {
          goToTariff(startedAt);
          setConsentCtx({ slug, wsId: targetWs.id });
          return;
        }
        await cardCheckout(slug, targetWs.id);
      } catch (e) {
        // Сюда приходит отказ СОЗДАНИЯ пространства (оплата и активация свои
        // ошибки гасят сами) — в том числе 400 workspace_limit_reached, лимит
        // пространств по выдаче персонального тарифа: текст отказа присылает
        // сервер (detail), показываем его как есть. Форма остаётся рабочей —
        // пространства нет, защёлка createdRef не стоит.
        // Запасной текст на пути персонального тарифа — про создание: оплаты там нет.
        toast.show((e && e.detail) || (e && e.message)
          || (isPersonal ? 'Не удалось создать пространство' : 'Не удалось начать оплату'), 'danger');
      }
      finally { endRun(); }
    };

    const consentPlan = consentCtx ? (allPlans.find((p) => p.slug === consentCtx.slug) || null) : null;

    // Персональный тариф не покупают и «бесплатным периодом» он не является —
    // кнопка называет то, что произойдёт: пространство будет создано.
    const payLabel = isPersonal
      ? 'Создать пространство'
      : isFastStart
        ? 'Начать бесплатно'
        : selected
          ? ('Оплатить ' + fmt.money(selected.plan.price_rub) + (selected.months === 1 ? ' ' + periodSuffix(selected.plan.period_days) : ' · ' + monthsLabel(selected.months)))
          : 'Оплатить тариф';

    return ReactDOM.createPortal(
      <div className="overlay overlay--modal" style={{ zIndex: 'var(--z-modal)' }}>
        <div className="overlay__backdrop" onClick={requestClose} />
        <div className="modal modal--md wizard" role="dialog" aria-modal="true">
          <div className="modal__head">
            <h2 className="modal__title t-h3">Создать бизнес-пространство</h2>
            {/* Крестик — кнопкой UI-kit: пока идёт создание, он заблокирован и это
                видно (.btn:disabled), а не просто молчит. Класс modal__close
                держит размеры и тач-цель крестика, как у остальных модалок. */}
            <Button variant="ghost" iconOnly="close" className="modal__close" aria-label="Закрыть"
              disabled={busy} aria-disabled={busy || undefined} onClick={requestClose} />
          </div>

          {done ? (
            <div className="modal__body">
              {/* финал бесплатного пути: ws создан, активное пространство уже переключено —
                  юзер остаётся в приложении. Четыре вида: подключён персональный тариф
                  ('granted' — имя тарифа и срок из ответа /trial/, без «7 дней»);
                  период активирован; тариф и так есть ('already' / 'paid_plan');
                  пространство ЗАКРЫТО (done.closed — 'demo_used' или сбой активации):
                  без зелёной галочки и «готово к работе», а под мастером уже открыта
                  вкладка «Тариф» */}
              <div className="stack stack-12" style={{ alignItems: 'center', textAlign: 'center', padding: 'var(--space-16) 0' }}>
                {done.closed
                  ? <span style={{ color: 'var(--text-mute)' }} aria-hidden="true"><Icon name="info" size={40} /></span>
                  : <span style={{ color: 'var(--status-ok)' }} aria-hidden="true"><Icon name="check-circle" size={40} /></span>}
                <h3 className="t-h3" style={{ margin: 0 }}>Пространство «{done.name}» создано</h3>
                <p className="t-body-sm text-mute" style={{ margin: 0, maxWidth: 420 }}>
                  {done.status === 'granted'
                    // дата — тем же видом, что «Действует до» на карточке тарифа
                    ? grantedPanelText(done.planName, done.expiresAt, fmt.date)
                    : done.status === 'activated'
                      ? ('Бесплатный период активирован: ' + done.days + ' '
                        + fmt.plural(done.days, 'день', 'дня', 'дней')
                        + ' полного доступа, карта не нужна. Команда и учётная система подключаются на соседних вкладках.')
                      : done.closed
                        // совет зависит от пути: после сбоя на персональном тарифе
                        // «выберите тариф» не говорим (closedPanelText)
                        ? closedPanelText(done.status, { personal: done.personal })
                        : 'Пространство готово к работе. Управлять тарифом можно на вкладке «Тариф».'}
                </p>
              </div>
            </div>
          ) : (
          <div className="modal__body">
            <div className="stack stack-16">
              <Field label="Название пространства" required error={err}
                hint={createdWs && !err ? 'Пространство уже создано. Переименовать его можно в настройках заведения.' : undefined}>
                <TextInput value={name} invalid={!!err} placeholder="Например: Кафе «Берёзка»"
                  disabled={!!createdWs}
                  onChange={(e) => { setName(e.target.value); setErr(null); }} autoFocus />
              </Field>

              {bizBases.length > 0 ? (
                <>
                  {bizBases.length > 1 && (
                    // Подписи — tierLabel: публичные без приставки «Business», а
                    // персональный тариф — коротким «Персональный» (переключатель
                    // не переносит подписи; полное имя тарифа — на карточке ниже).
                    <Segmented ariaLabel="Выбор тарифа" value={tier ? tier.slug : null}
                      onChange={setTierSlug}
                      options={bizBases.map((p) => ({ value: p.slug, label: tierLabel(p, personal) }))} />
                  )}

                  <div className="wizard__plan stack stack-8"
                    data-onb={isPersonal ? 'buw-personal-plan' : (isFastStart ? 'buw-fast-start' : undefined)}>
                    {/* «Быстрый старт» — бесплатная рекомендация: бейдж + подсказка
                        над карточкой (цена «Бесплатно» приходит из API как 0) */}
                    {isFastStart && (
                      <div className="cluster cluster-8">
                        <Pill tone="accent" glyph={false} size="sm">рекомендуем</Pill>
                        <span className="t-caption text-mute">7 дней, без карты</span>
                      </div>
                    )}
                    {/* Персональный тариф: бейдж говорит, чей он, рядом — срок доступа
                        по выдаче («Бессрочно» / «N дней»). Подписей «Быстрого старта»
                        («7 дней, без карты») здесь нет: срок у выдачи свой. Срок,
                        который не прочитать, не называем (пустая подпись). */}
                    {isPersonal && (
                      <div className="cluster cluster-8">
                        <Pill tone="accent" glyph={false} size="sm">Персональный</Pill>
                        {personalTerm && <span className="t-caption text-mute">{personalTerm}</span>}
                      </div>
                    )}
                    {/* карточка без action-кнопки — единый CTA оплаты в футере (P3-14) */}
                    <PlanCard plan={cardPlan} currentPrice={0} subscription={{ plan: 'demo' }} showAction={false} busy={busy} />
                    {/* Откуда тариф и что будет по кнопке; счётчик пространств по
                        выдаче — справка, а не замок (лимит проверяет сервер). */}
                    {isPersonal && (
                      <div className="stack stack-4">
                        <span className="t-caption text-mute">Тариф выдан вашему аккаунту: пространство откроется на нём сразу, без оплаты.</span>
                        {personalUsage && <span className="t-caption text-mute">{personalUsage}</span>}
                      </div>
                    )}
                  </div>

                  {options.length > 1 && (
                    <div className="stack stack-8">
                      <span className="t-label">Срок оплаты <span className="text-mute">— чем длиннее, тем выгоднее</span></span>
                      <ul className="period-opts">
                        {options.map((o) => {
                          const isSel = o.months === months;
                          const isBest = o.discountPct > 0 && o.discountPct === bestPct;
                          const has = o.discountPct > 0;
                          return (
                            <li key={o.plan.slug}>
                              <button type="button"
                                className={'period-opt period-opt--select' + (isSel ? ' is-selected' : '') + (isBest ? ' is-best' : '')}
                                aria-pressed={isSel} onClick={() => setMonths(o.months)} disabled={busy}>
                                <span className="period-opt__check"><Icon name={isSel ? 'check' : 'circle'} size={16} /></span>
                                <div className="period-opt__main">
                                  <div className="period-opt__head">
                                    <span className="period-opt__term t-label">{monthsLabel(o.months)}</span>
                                    {has && <Pill tone="ok" glyph={false} size="sm">−{o.discountPct}%</Pill>}
                                    {isBest && <Pill tone="accent" glyph={false} size="sm">выгоднее всего</Pill>}
                                  </div>
                                  <div className="period-opt__price">
                                    <span className="period-opt__permonth num">{fmt.money(o.perMonth)}<span className="text-mute"> / мес</span></span>
                                    <span className="period-opt__total t-caption text-mute">
                                      {o.months === 1
                                        ? 'оплата помесячно'
                                        : (fmt.money(o.plan.price_rub) + ' за ' + monthsLabel(o.months))}
                                      {has && (' · экономия ' + fmt.money(o.savings))}
                                    </span>
                                  </div>
                                </div>
                              </button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <span className="skeleton" style={{ height: 320, borderRadius: 'var(--radius-lg)', display: 'block' }} />
              )}
            </div>
          </div>
          )}

          {/* Прогон затянулся: окно заперто, и человеку надо сказать, что происходит.
              Строка стоит между телом и футером — тело прокручивается, а она на виду. */}
          {busy && slow && (
            <p className="t-caption text-mute" role="status"
              style={{ padding: '0 var(--space-20) var(--space-12)' }}>
              Запрос выполняется дольше обычного. Если окно не закроется, обновите страницу.
            </p>
          )}

          <div className="modal__foot">
            <div className="modal__foot-left" />
            <div className="modal__foot-actions cluster cluster-4">
              {done ? (
                // Закрытое пространство: под окном уже открыта вкладка «Тариф», и
                // кнопка называет её, а не обещает «работу» с галочкой.
                done.closed
                  ? <Button variant="primary" onClick={close}>Перейти к тарифу</Button>
                  : <Button variant="primary" iconLeft="check" onClick={close}>Начать работу</Button>
              ) : (
                <>
                  <Button variant="ghost" onClick={requestClose} disabled={busy}>Отмена</Button>
                  <Button variant="primary" iconLeft={isFreePath ? 'check' : 'credit-card'} loading={busy} disabled={busy || !selected || !name.trim()} onClick={pay}>{payLabel}</Button>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Безнал (Точка): развилка способа оплаты после создания ws на платном тарифе.
            Карта → тот же checkout; счёт → форма реквизитов и создание счёта. */}
        {showInvoicePay && (
          <PaymentMethodModal
            open={!!payMethod}
            plan={payMethod ? (allPlans.find((p) => p.slug === payMethod.slug) || null) : null}
            busy={busy}
            onClose={() => setPayMethod(null)}
            onPickCard={() => { const m = payMethod; setPayMethod(null); if (m) payByCard(m.slug, m.ws.id); }}
            onPickInvoice={() => { setInvoiceCtx(payMethod); setPayMethod(null); }} />
        )}
        {/* Согласие на автосписания — последний шаг перед Робокассой. Пространство
            к этому моменту уже создано; закрытие окна оплату не начинает. */}
        <RecurringConsentModal
          open={!!consentCtx}
          planName={consentPlan ? consentPlan.name : ''}
          priceRub={consentPlan ? consentPlan.price_rub : null}
          periodDays={consentPlan ? consentPlan.period_days : null}
          busy={busy}
          onClose={() => setConsentCtx(null)}
          onConfirm={() => { if (consentCtx) cardCheckout(consentCtx.slug, consentCtx.wsId, true); }} />
        {phoneGate.modal}
        {showInvoicePay && (
          <InvoicePayModal
            open={!!invoiceCtx}
            fixedPlanSlug={invoiceCtx ? invoiceCtx.slug : null}
            plans={allPlans}
            wsId={invoiceCtx ? invoiceCtx.ws.id : undefined}
            onClose={() => setInvoiceCtx(null)}
            onCreated={async (invoiceId) => {
              const wsId = invoiceCtx ? invoiceCtx.ws.id : undefined;
              // Счёт выставлен — уходим на его страницу уже в новом пространстве.
              if (wsId) await activate(wsId);
              setInvoiceCtx(null); close();
              navigate('/checkout/invoice/' + encodeURIComponent(invoiceId) + (wsId ? '?ws=' + encodeURIComponent(wsId) : ''));
            }} />
        )}
      </div>,
      getOverlayRoot()
    );
  }

export { BusinessUpgradeWizard };
